import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'backoffice-aggregates-subnavigation',
  templateUrl: './aggregates-subnavigation.component.html',
  styleUrls: ['./aggregates-subnavigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AggregatesSubnavigationComponent {}
